






















































import Vue from "vue";
import iwTabsLanguageSwitcher from "@/encoding/components/buildingBlocks/tabsLanguageSwitcher/TabsLanguageSwitcher.vue";
import iwAiDescriptionPanel from "@/shared/components/AiDescriptionPanel.vue";
import "@/assets/sass/optimizedEncoding/optimizedEncoding.scss";
import { updateClassified } from "@/shared/scripts/ValidateData";
import { generateContent } from "@/shared/scripts/aiGeneratedContent";
import { hasOverLongTitle } from "@/shared/scripts/helpers/titleValidation";
import { Trans } from "@/shared/scripts/helpers/translation/translation";
import { pushPageViewEvent } from "@/shared/store/modules/gtm/datalayer";

export default Vue.extend({
    components: {
        iwTabsLanguageSwitcher: iwTabsLanguageSwitcher,
        iwAiDescriptionPanel: iwAiDescriptionPanel,
    },

    props: {
        isNextSectionVisible: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data: function() {
        return {
            activeTabLanguage: "en" as string,
            tabsLabelId: "ai-description-tabs" as string,
            isTitleLoaded: false as boolean,
            liveDescriptionContent: {} as Record<string, string>,
        };
    },

    computed: {
        // Title errors are rendered against the title input itself by the tabs component.
        getErrorMessage: function(): string {
            return this.$store.getters["FormModule/getErrorObjectByPath"]("property.description.en") ||
                this.$store.getters["FormModule/getErrorObjectByPath"]("property.description.nl") ||
                this.$store.getters["FormModule/getErrorObjectByPath"]("property.description.fr") || "";
        },

        languages: function(): Array<Record<string, unknown>> {
            return [
                { language: this.$t("english_language"), prefix: "en", validate: false },
                { language: this.$t("french_language"), prefix: "fr", validate: false },
                { language: this.$t("dutch_language"), prefix: "nl", validate: false }
            ];
        },
        price: function(): boolean {
            const transactionPricing = this.$store.getters["FormModule/getValue"]("transaction.sale.price");
            const transactionRentalMonthlyPrice = this.$store.getters["FormModule/getValue"]("transaction.rental.monthlyRentalPrice");

            return transactionPricing || transactionRentalMonthlyPrice;
        },

        isFormValid: function(): boolean {
            const getter = this.$store.getters["FormModule/getValue"];
            if (!getter || typeof getter !== "function") {
                return false;
            }

            const titles = getter("property.title") || {};
            const descriptions = getter("property.description") || {};

            // Every filled-in locale is sent to the API, so one over-long title sinks the request.
            if (hasOverLongTitle(titles)) {
                return false;
            }

            return this.languages.some((lang) => {
                const code = (lang.prefix as string).toLowerCase();
                return titles[code] && titles[code].trim() !== "" &&
                    descriptions[code] && descriptions[code].trim() !== "";
            });
        }
    },

    created: async function () {
        pushPageViewEvent("classified_deposit_v2_step7_description");
        try {
            this.activeTabLanguage = Trans.currentLocale;
            await this.generateAiTitle();
        } catch (e) {
            console.error(e);
        }
    },

    methods: {
        handleTabLanguageChange: function(language: string) {
            this.activeTabLanguage = language;
        },

        handleDescriptionLiveUpdate: function(payload: { locale: string; value: string }) {
            this.$set(this.liveDescriptionContent, payload.locale, payload.value);
        },

        handleLanguageChange: function(value: string) {
            this.$emit("language-selected", value);
        },

        validateAndContinue: function() {
            if (this.isFormValid) {
                updateClassified((success: boolean) => {
                    if (success) {
                        this.$emit("section-completed");
                    }
                });
            }
        },

        generateAiTitle: async function() {
            const classifiedId = this.$store.getters["FormModule/getClassifiedId"];

            if (!classifiedId) {
                this.isTitleLoaded = true;
                return;
            }

            const language = this.activeTabLanguage;
            const existingTitle = this.$store.getters["FormModule/getValue"](`property.title.${language}`);

            if (typeof existingTitle === "string" && existingTitle.trim().length > 0) {
                this.isTitleLoaded = true;
                return;
            }

            try {
                const response = await generateContent({
                    classifiedId: classifiedId,
                    fields: ["title"],
                    language: language,
                });

                this.$store.dispatch("FormModule/addValue", {
                    path: `property.title.${language}`,
                    value: response.title || "",
                });

            } catch (error) {
                this.dialog?.alert(this.$t("server_not_responding_error").toString());
            } finally {
                this.isTitleLoaded = true;
            }
        },
    }
});
